/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'DashboardWrap';

const classes = {
  addButton: `${PREFIX}-addButton`,
};

const Root = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(9.5),
  paddingBottom: theme.spacing(23.5),
  position: 'relative',
  zIndex: 0,

  [`& .${classes.addButton}`]: {
    width: '100%',
    height: '56px',
    background: '#202020',
    padding: theme.spacing(0, 4),
    borderRadius: '8px',
    color: '#f1f1f1',
    transition: 'background 0.2s',

    '&:hover': {
      background: '#2b2b2b',
    },
  },
}));

export {Root as DashboardWrapRoot, classes as DashboardWrapClasses};
